import { HTMLAttributes } from "react";

export const SOLUTIONS = {
  core: "Core Solutions",
  advanced: "Advanced Solutions",
  tooling: "Tooling Solutions",
  "forge-build": "Forge & Build",
} as const;

export type SolutionName = (typeof SOLUTIONS)[keyof typeof SOLUTIONS];

export type SolutionSlug = keyof typeof SOLUTIONS;

export type SolutionIconProps = {
  solutionSlug?: SolutionSlug;
  solutionName?: SolutionName;
} & HTMLAttributes<HTMLImageElement>;
